import { ListItem, ListItemText, Typography } from "@mui/material";
import { SearchServiceOrder } from "../../../../entities/service-order/api/search-service-orders";
import { PaperCard } from "../../../../shared/ui/paper-card/paper-card.component";
import ServiceOrderListItemComponent from "./service-order-list-item.component";

interface ServiceOrdersListComponentProps {
  props: {
    serviceOrders: SearchServiceOrder[];
  };
}

export const ServiceOrdersListComponent = ({ props }: ServiceOrdersListComponentProps) => {
  const { serviceOrders } = props;

  return (
    <PaperCard title={`Lista - mostrando ${serviceOrders.length} ordem(s) de serviço encontrada(s)`}>
      <ListItem
        divider
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
          textAlign: "center",
          marginTop: "2rem"
        }}
      >
        {["CLIENTE", "DATA", "TOTAL DE LINHAS", "STATUS"].map((item, idx) => (
          <ListItemText id={`service-order-list-header-${item}`} primary={item} sx={{ flex: "1", fontWeight: "bold" }} key={item} />
        ))}
      </ListItem>
      {serviceOrders.map((serviceOrder) => (
        <ServiceOrderListItemComponent serviceOrder={serviceOrder} key={serviceOrder.service_order_id} />
      ))}
    </PaperCard>
  );
};

export default ServiceOrdersListComponent;
